// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { Analytics } from '@trello/atlassian-analytics';
import { doesCardOnlyHaveName } from '@trello/card-roles';
import { featureFlagClient } from '@trello/feature-flag-client';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { QuickCardEditorView } from 'app/scripts/views/card/QuickCardEditorView';
import { getSeparatorClassName } from 'app/scripts/views/card/SeparatorCard/SeparatorCard';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { CardTitleOnCardFrontTemplate } from 'app/scripts/views/templates/CardTitleOnCardFrontTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const renderName = function (this: any) {
  const data = this.model.toJSON();

  if (
    !featureFlagClient.get('workflowers.unship-separator-metadata', false) ||
    doesCardOnlyHaveName({
      description: data?.desc,
      numAttachments: data?.badges?.attachments,
      numChecklistItems: data?.badges?.checkItems,
      numCustomFieldItems: this.model.customFieldItemList?.length ?? 0,
      numLabels: data?.idLabels?.length ?? 0,
      numMembers: data?.idMembers?.length ?? 0,
      startDate: data?.start,
      dueDate: data?.due,
      cover: data?.cover,
    })
  ) {
    data.separatorClassName = getSeparatorClassName(data.name);
  }

  const html = CardTitleOnCardFrontTemplate(data);

  $('.js-card-name', this.$el).html(html);

  return this;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const openQuickCardEditor = function (this: any, e: any) {
  if (this.options.quickEditHidden || !this.model.editable()) {
    return;
  }

  stopPropagationAndPreventDefault(e);
  PopOver.hide();
  QuickCardEditorView.open(this);
  Analytics.sendClickedButtonEvent({
    buttonName: 'quickCardEditorButton',
    source: 'cardView',
    containers: this.model?.getAnalyticsContainers(),
  });

  return this;
};

export { renderName };
export { openQuickCardEditor };
